import Config from "../constant/Config";
import { fetchJsonIfOk } from "./ServiceUtils";

export const getUser = async (userId) => {
  return await fetchJsonIfOk(`${Config.apiurl}/user/${userId}`);
}
